import { API_BASE_URL } from '../config/api';
import { getToken } from './authApi';

const BASE = `${API_BASE_URL}/push`;

async function authFetch(path: string, init: RequestInit): Promise<Response> {
  const token = getToken();
  if (!token) {
    throw new Error('Chưa đăng nhập');
  }
  return fetch(`${BASE}${path}`, {
    ...init,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...(init.headers || {}),
    },
  });
}

export const pushApi = {
  registerToken: async (deviceToken: string, platform = 'android'): Promise<void> => {
    const res = await authFetch('/register', {
      method: 'POST',
      body: JSON.stringify({ token: deviceToken, platform }),
    });
    if (!res.ok) {
      const detail = await res.text();
      throw new Error(detail || 'Không đăng ký được push token');
    }
  },

  unregisterToken: async (deviceToken: string): Promise<void> => {
    const res = await authFetch('/unregister', {
      method: 'POST',
      body: JSON.stringify({ token: deviceToken }),
    });
    if (!res.ok) {
      const detail = await res.text();
      throw new Error(detail || 'Không hủy được push token');
    }
  },
};
